import React, {useContext, useEffect, useState} from "react"

// context, util, config & data
import {ShopContext} from "../../../context/ShopContext"
import {CatalogueContext} from "../../../context/CatalogueContext"
import Util from "../../../util"
import Config from "../../../config"
import data from "../../../data"

// components
import Checkout from "./Checkout"
import PaymentTypes from "./PaymentTypes"
import {Checkbox, Form} from "../../controls"
import {Scaffolding} from "../../shared"

// styling
import "./Payment.scss"

// form fields
const paymentFields = Config.paymentFields
const shippingFields = Config.shippingFields

// the component
function Payment() {
  // state managment
  const [shippingIsDifferent, setShippingIsDifferent] = useState(false)
  
  // context
  const catalogue = useContext(CatalogueContext)
  const shop = useContext(ShopContext)
  
  // scroll to top when mounting
  useEffect(() => { Util.Scroll.scrollToTop()}, [])
  
  // mounting?
  useEffect(() => {
    if(catalogue.isReady) {
      setShippingIsDifferent(data.Cart.getShippingIsDifferent())
    }
  },[catalogue.isReady])

  // shop not yet loaded its data?
  if(!catalogue.isReady) {
    return null
  }

  // event handlers
  const onPaymentFormUpdate = (e) => {
    data.Cart.setPaymentAddress(e.entity)
    validate()
  }

  const onShippingFormUpdate = (e) => {
    data.Cart.setShippingAddress(e.entity)
    validate()
  }

  const onChangeShippingIsDifferent = (e) => {
    setShippingIsDifferent(e.checked)
    data.Cart.setShippingIsDifferent(e.checked)
    validate()
  }

  const validate = () => {
    let validation = data.Cart.getValidation()
    shop.cart.setValidation(validation)
  }

  // render
  const paymentEntity = data.Cart.getPaymentAddress()
  const shippingEntity = data.Cart.getShippingAddress()

  // if this is the first time the user arrives here, we don't want to display field validation messages
  const hideFieldValidation = data.Storage.getCheckoutProgress() <= 3
  
  return (
    <Scaffolding>
      <Checkout stepName="payment" title="Bezahlung & Versand">
        <div id="v-payment">
          <div id="v-payment-kind">
            <h2>Zahlungsart</h2>
            <PaymentTypes value={data.Cart.getPaymentType()} />
          </div>

          <div id="v-payment-paymentaddress">
            <h2>Rechnungsadresse</h2>
            <p>Gib hier deine Adresse ein</p>
            <Form 
              fields={paymentFields} 
              entity={paymentEntity} 
              onUpdate={onPaymentFormUpdate} 
              hideFieldValidation={hideFieldValidation}
            />
          </div>

          <div id="v-payment-differingaddresses">
            <div>
              <Checkbox 
                checked={data.Cart.getShippingIsDifferent()}
                onChange={onChangeShippingIsDifferent} 
              >
                abweichende Versandadresse
              </Checkbox>
            </div>
          </div>
          
          {
            shippingIsDifferent && 
              <div id="v-payment-shippingaddress">
                <h2>Versandadresse</h2>
                <p>An diese Adresse senden wir das Geschenk</p>
                <Form 
                  fields={shippingFields} 
                  entity={shippingEntity} 
                  onUpdate={onShippingFormUpdate} 
                  hideFieldValidation={hideFieldValidation}
                />
              </div>
            
          }
        </div>
      </Checkout>
    </Scaffolding>
  )
}

export default Payment